import { Action, CustomTagType, DockType, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import OfferDialog from "../../components/SupplierView/OfferDialog/OfferDialog";
import InstructionsAndNotes from "../../components/SupplierView/OfferDialog/Instructions/InstructionsAndNotes";
import ClaimOfferDialog from "../../components/SupplierView/OfferDialog/ClaimOffer/ClaimOfferDialog";

export const job_phase_view_offer: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: "'/jobPhase/' + {submissionData.taskId} +'/offer'"
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionData.submissionName}',
        submissionId: '{submissionData.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  className: 'xxxl offer',
  data: {
    notificationIcon: 'error',
    notificationText: 'offer.cvaText',
    notificationType: 'warning'
  },
  children: [{
    render: OfferDialog,
    propArgs: [
      'responseData',
      'submissionData'
    ]
  }],
  items: [{
    operations: [],
    btnName: 'offerHeader',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'leaveOfferDialogCheck',
      type: OperationType.action
    }]
  }, {
    btnName: 'offer.cvaLabel',
    btnConfig: {
      pos: Position.start,
      args: ['notificationText', 'notificationType', 'notificationIcon'],
      customTagType: CustomTagType.notificationLabel,
      hidden: true,
    }
  }, {
    btnName: 'offer.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    close: false,
    operations: [{
      name: 'leaveOfferDialogCheck',
      type: OperationType.action
    }]
  }, {
    btnName: 'offer.close',
    btnConfig: {
      hidden: true,
      fillMode: 'flat',
      pos: Position.end
    },
    close: false,
    operations: [{
      name: 'leaveOfferDialogCheck',
      type: OperationType.action
    }]
  }, {
    close: false,
    btnName: 'offer.next',
    btnConfig: {
      disabled: true,
      pos: Position.end,
      themeColor: 'primary'
    },
    operations: [{
      name: 'checkForAllDeclined',
      type: OperationType.action
    }]
  }],
  title: 'offer.title',
  type: OperationType.dialog
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}]

export const checkForAllDeclined: Action = [{
  moduleName: 'OfferDialog',
  name: 'hasAllTaskDeclined',
  type: OperationType.addOperationData
}, {
  condition: '{hasAllTaskDeclined}',
  conditionOperations: [{
    name: 'declineAllWarning',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'nextButtonHandler',
    type: OperationType.action
  }],
  type: OperationType.conditional
},]

export const declineAllWarning: Action = [{
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'declineAllWarning.title',
  text: 'declineAllWarning.text',
  items: [{
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'declineAllWarning.submit',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    },
    operations: [{
      moduleName: 'OfferDialog',
      name: 'getPostData',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          bind: {
            offerRequestUrl: '"/jobPhase/" + {getPostData.submissionId} + "/offer"',
            offerDialogPost: '{getPostData.postData}'
          }
        }
      },
      type: OperationType.data
    }, {
      name: 'submitOfferClaim',
      type: OperationType.action
    }]
  }],
  type: OperationType.warning
}]

export const leaveOfferWarning: Action = [{
  className: 'sm confirm-light',
  title: 'leaveOfferWarning.title',
  text: 'leaveOfferWarning.text',
  items: [{
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'leaveOfferWarning.submit',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    },
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }]
  }],
  type: OperationType.warning
}]

export const leaveOfferDialogCheck: Action = [{
  moduleName: 'OfferDialog',
  name: 'hasChanges',
  type: OperationType.addOperationData
}, {
  condition: '{hasChanges}',
  conditionOperations: [{
    name: 'leaveOfferWarning',
    type: OperationType.action
  }],
  elseOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}]

export const updateFooterButtons: Action = [{
  data: {
    notificationText: 'offer.cvaText',
    notificationType: 'warning',
    notificationIcon: 'error'
  },
  type: OperationType.data
}, {
  customTags: [{
    name: 'offer.cvaLabel',
    args: ['notificationText', 'notificationType', 'notificationIcon'],
    hidden: '!{displayCVABadge}'
  }],
  buttons: [{
    name: 'offer.next',
    disabled: '!{enableNext}'
  }],
  type: OperationType.updateDialog
}]

export const updateReadOnlyOfferDialog: Action = [{
  buttons: [{
    name: 'offer.cancel',
    hidden: '{showClose}'
  }, {
    name: 'offer.close',
    hidden: '!{showClose}'
  }, {
    name: 'offer.next',
    hidden: '{hideNext}'
  }],
  type: OperationType.updateDialog
}]

export const openBackgroundInstructionsDialog: Action = [{
  className: 'md instructions-and-notes',
  children: [{
    render: InstructionsAndNotes,
    propArgs: ['background', 'instructions', 'phaseType', 'backgroundEnabled', 'instructionsEnabled', 'submissionId']
  }],
  items: [{
    btnName: 'common.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  title: 'instructionsAndNotes.title',
  type: OperationType.dialog
}];

export const nextButtonHandler: Action = [{
  moduleName: 'OfferDialog',
  name: 'getClaimOfferDialogData',
  mappingName: 'offerClaimDialogData',
  type: OperationType.addOperationData
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{offerClaimDialogData.submissionData.submissionName}',
        submissionId: '{offerClaimDialogData.submissionData.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  className: 'xl claim-offer',
  children: [{
    render: ClaimOfferDialog,
    propArgs: ['offerClaimDialogData']
  }],
  items: [{
    operations: [],
    btnName: 'offerHeader',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    }
  }],
  title: 'claimOffer.title',
  type: OperationType.dialog
}];

export const closeOfferClaim: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const submitOfferClaim = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  data: {
    method: 'post',
    template: {
      bind: {
        url: '{offerRequestUrl}',
        params: '{offerDialogPost}'
      }
    },
  },
  handleErrorStatuses: [
    ErrorCodes.FORBIDDEN,
    ErrorCodes.NOT_FOUND,
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.INTERNAL_SERVER_ERROR
  ],
  mappingName: 'offerPost',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{offerPost}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        url: `{offerRequestUrl}`,
      },
      afterPingFinishAction: 'afterOfferClaimPinging',
      method: 'post'
    }
  },
  name: 'pingingRequest',
  type: OperationType.action
}];

export const afterOfferClaimPinging: Action = [{
  name: 'refreshApp',
  type: OperationType.action
}];
